import { WalletCard, useListBackerConsumerWallet } from '@givebacks/api/backer';
import { Modal, ModalProps, Skeleton, Stack } from 'ui';

import { ConsumerWalletListCard } from '../ConsumerWalletCard/ConsumerWalletListCard';
import classes from './ExpiredAccountCardsModal.module.css';

type ExpiredAccountCardsModalProps = ModalProps & {
  filterFn: (data: WalletCard[]) => WalletCard[];
  getKey: (card: WalletCard) => string | undefined;
};

const ExpiredAccountCardsContent = ({
  filterFn,
  getKey,
}: {
  filterFn: (data: WalletCard[]) => WalletCard[];
  getKey: (card: WalletCard) => string | undefined;
}) => {
  const { data: walletCards, isLoading } = useListBackerConsumerWallet({
    expired: true,
    select: filterFn,
  });

  return (
    <Skeleton visible={isLoading}>
      <Stack className={classes.ExpiredAccountCardsModal}>
        {walletCards?.map((card) => (
          <ConsumerWalletListCard walletCard={card} key={getKey(card)} />
        ))}
      </Stack>
    </Skeleton>
  );
};

const ExpiredAccountCardsModal = ({
  onClose,
  opened,
  filterFn,
  getKey,
}: ExpiredAccountCardsModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title="View Expired">
      <ExpiredAccountCardsContent filterFn={filterFn} getKey={getKey} />
    </Modal>
  );
};

export { ExpiredAccountCardsModal };
